export default "__VITE_ASSET__b13e4720__"